export default __webpack_public_path__ + "static/media/FOTO4.780fcd05.jpg";